import { Route } from 'react-router-dom'

export default function ConditionalRoute({if: condition, ...props}) {
  if(condition) {
    return <Route {...props} />
  } else {
    return <></>
  }
}
